import React from 'react';
import { useLocation } from 'react-router-dom';

const PRIVACY = [
  ['Information we collect', 'Business account details, call recordings and transcripts, caller phone numbers and appointment details provided during calls.'],
  ['How we use it', 'To answer calls, schedule appointments, send appointment texts and notify business owners. We do not sell personal information.'],
  ['Text messaging', 'Mobile numbers and SMS opt-in consent are never shared with or sold to third parties or affiliates for marketing purposes. Reply STOP to any message to opt out.'],
  ['Data retention', 'Call data is kept while the business account is active and deleted on request.'],
  ['Contact', 'support@frontdeskpro.org'],
];

const TERMS = [
  ['Service', 'Front Desk Pro provides AI phone receptionist software to businesses on a monthly plan. Plans can be cancelled anytime; setup fees are non-refundable.'],
  ['Text messaging program', 'Customers of businesses using Front Desk Pro may opt in to appointment texts during a call. Message frequency varies. Message and data rates may apply. Reply STOP to cancel and HELP for help. Carriers are not liable for delayed or undelivered messages.'],
  ['Acceptable use', 'Businesses must not use the service for spam, illegal content or messages to people who have not opted in.'],
  ['Contact', 'support@frontdeskpro.org'],
];

export default function LegalPage() {
  const isPrivacy = useLocation().pathname === '/privacy';
  const sections = isPrivacy ? PRIVACY : TERMS;
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4" data-testid={isPrivacy ? 'privacy-page' : 'terms-page'}>
      <div className="max-w-2xl mx-auto bg-white border border-slate-200 rounded-xl p-8 space-y-5 text-slate-700">
        <h1 className="text-3xl font-bold text-slate-900">{isPrivacy ? 'Privacy Policy' : 'Terms of Service'}</h1>
        <p className="text-sm text-slate-500">Front Desk Pro · Last updated June 2026</p>
        {sections.map(([h, p]) => (
          <div key={h}>
            <h2 className="text-lg font-semibold text-slate-900 mb-1">{h}</h2>
            <p>{p}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
